import * as React from "react";
import { SVGProps } from "react";

const Uma = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 255 63"
    {...props}
  >
    <style>{".st0{fill:#ff4a4a}"}</style>
    <path
      d="M163.4 63.8h-10.8c-2 0-3.7-1.6-3.7-3.7V31.7L130 43.5c-1.6 1-3.6 1-5.2 0L106 31.7v28.4c0 2-1.6 3.7-3.7 3.7H91.6c-2 0-3.7-1.6-3.7-3.7V5.3c0-2.7 2.2-4.9 4.9-4.9 1 0 1.9.3 2.7.9l29.8 20.5c1.2.9 2.9.9 4.1 0l29.8-20.5c2.2-1.5 5.3-.9 6.8 1.3.6.8.8 1.8.9 2.7v54.8c.1 2-1.5 3.7-3.5 3.7zm-91.6-.1h-67c-2.7 0-4.9-2.2-4.9-4.9V3.7C0 1.6 1.6 0 3.7 0h10.8c2 0 3.7 1.6 3.7 3.7v41.9h40.6V3.7c0-2 1.6-3.7 3.7-3.7H73c2 0 3.7 1.6 3.7 3.7v55.1c0 2.7-2.2 4.9-4.9 4.9zM183.2 0h67c2.7 0 4.9 2.2 4.9 4.9V60c0 2-1.6 3.7-3.6 3.7h-10.8c-2 0-3.7-1.6-3.7-3.7V20.5c0-1.3-1.1-2.4-2.4-2.4h-35.7c-1.3 0-2.4 1.1-2.4 2.4V60c0 2-1.6 3.7-3.7 3.7H182c-2 0-3.7-1.6-3.7-3.7V4.9c0-2.7 2.2-4.9 4.9-4.9z"
      className="st0"
    />
    <path
      d="M211.3 29.7H222c2 0 3.7 1.6 3.7 3.7v10.9c0 2-1.6 3.7-3.7 3.7h-10.7c-2 0-3.7-1.6-3.7-3.7v-11c0-2 1.7-3.6 3.7-3.6z"
      className="st0"
    />
  </svg>
);

export default Uma;
